import { type InferProps } from 'prop-types'
import { type FunctionComponent } from 'react'

import { PRICE_TYPES } from 'shared/consts/productTemplates'
import store from 'shared/store'
import { getPriceForType } from 'shared/utils/productTemplateUtils'
import {
  currencyToSymbol,
  formatPriceString,
} from 'views/components/atoms/Price/helpers'
import Price_v1 from 'views/utils/propTypes/api/Price_v1'

type ItemPriceArguments = {
  prices: InferProps<typeof Price_v1>[]
}

const ItemPrice: FunctionComponent<ItemPriceArguments> = ({ prices }) => {
  const {
    publicConfig: { locale },
  } = store.getPublicRuntimeConfig()
  const { amount } = getPriceForType(prices, PRICE_TYPES.RETAIL)
  const currencySymbol = currencyToSymbol('EUR')

  return (
    <span>
      {formatPriceString({
        amount,
        locale,
        currencySymbol,
        symbolRight: false,
      })}
    </span>
  )
}

export default ItemPrice
